import { useIntl } from "react-intl";

import usePermissions from "hooks/usePermissions";
import useCustomBrokerPermission from "hooks/useCustomBrokerPermission";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import { useGetQuickRequestDetails } from "api/queries/quick-request/useGetQuickRequestDetails";
import EditSchedule from "components/molecules/TopNav/provider/NavIcons/EditSchedule";

interface ProviderActionIconButtonsProps {
  isQuickRequest: boolean;
  shipmentId: string;
  tabTitle: string;
  isLoading: boolean;
}

export default function ProviderActionIconButtons({
  isQuickRequest,
  shipmentId,
  tabTitle,
  isLoading,
}: ProviderActionIconButtonsProps) {
  const intl = useIntl();
  const [isCustomBroker] = useCustomBrokerPermission(isQuickRequest);

  const trackingTabTitle = intl.formatMessage({ id: "general.tracking", defaultMessage: "Tracking" });

  const { data: shipmentData }: any = useGetShipmentBasic(shipmentId, {
    enabled: !isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });
  const { data: quickDetailsData }: any = useGetQuickRequestDetails(shipmentId, {
    enabled: isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });
  const { data: shipmentDetailsData = {} } = useGetShipmentDetails(shipmentId, true, {
    enabled: !!shipmentId && tabTitle === trackingTabTitle,
    refetchOnMount: false,
  });

  const { shipment } = shipmentData || {};
  const { permissions } = usePermissions();
  const { user_type, company_name } = JSON.parse(permissions || "{}");
  const isShipper = user_type === "shipper";

  const status = isQuickRequest
    ? quickDetailsData?.organization?.quick_request_status
    : shipmentData?.organization?.request_status;

  const isOffPlatform = shipment?.is_off_platform_shipment || false;

  // Permissions
  const canEditSchedule =
    tabTitle === trackingTabTitle &&
    !isOffPlatform &&
    !["Canceled", "Auto canceled", "Delivered"].includes(status) &&
    !isShipper &&
    (!isCustomBroker || shipmentDetailsData?.organization?.company_name === company_name);

  if (isLoading) return null;

  return (
    <>
      {/* Edit schedule (provider tracking only — won't show for shippers, but kept for completeness) */}
      {canEditSchedule && <EditSchedule />}
    </>
  );
}
